function i18nRun($localStorage, bbi18nOptions, bbLocale, RuntimeTranslate, bbTimeZone, bbTimeZoneOptions) {
    'ngInject';
    RuntimeTranslate.registerAvailableLanguageKeys(
        bbi18nOptions.available_languages,
        bbi18nOptions.available_language_associations
    );

    bbLocale.determineLocale();
    bbTimeZone.determine();
}

export default i18nRun;



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-i18n/main.run.js